import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

import BaseSvg, { Props } from '../BaseSvg'

const CasavoAssistant: React.FC<Props> = (props) => (
  <BaseSvg
    className={sprinkles({
      fill: 'none',
    })}
    height="20"
    viewBox="0 0 20 20"
    width="20"
    {...props}
  >
    <path
      d="M19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10Z"
      stroke="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M10.0028 5.29395C11.6271 5.29395 12.9439 6.61075 12.9439 8.23512C12.9439 8.84236 12.7599 9.40661 12.4446 9.87516L12.3557 9.99983C13.6552 9.99983 14.7086 11.0533 14.7086 12.3528V14.7057H5.29688V12.3528C5.29688 11.0533 6.35032 9.99983 7.64982 9.99983C7.28058 9.50885 7.06158 8.89756 7.06158 8.23512C7.06158 6.61075 8.37839 5.29395 10.0028 5.29395ZM12.3557 11.1763H7.64982C7.0296 11.1763 6.52148 11.6562 6.47657 12.265L6.47335 12.3528V13.5292H13.5322V12.3528C13.5322 11.7326 13.0522 11.2244 12.4435 11.1795L12.3557 11.1763ZM10.0028 6.47042C9.02814 6.47042 8.23805 7.2605 8.23805 8.23512C8.23805 9.20974 9.02814 9.99983 10.0028 9.99983C10.9774 9.99983 11.7675 9.20974 11.7675 8.23512C11.7675 7.2605 10.9774 6.47042 10.0028 6.47042Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </BaseSvg>
)

export default CasavoAssistant
